import { projectContext } from "@/layouts/MainLayout"
import { getMaterialBalances } from "@/services/project/material-balance.service"
import { useRequest } from "ahooks"
import { useContext, useMemo, useState } from "react"
import { CreateMaterialBalanceCard, MaterialBalanceCard } from "./MaterialBalanceCard"
import styles from './styles.module.less'
import outStyles from '../index.module.less'
import classNames from "classnames"
import { Input, Space } from "antd"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_CHEMENG } from "@/components/OPermission/PlanPermission"
const { Search } = Input;

export const MaterialBalances = () => {
  const { projectId } = useContext(projectContext)
  const { data = [], refresh } = useRequest(() => getMaterialBalances(projectId))
  const [search, setSearch] = useState('')

  const onSearch = (text: string = '') => {
    setSearch(text)
  }

  const filteredData = useMemo(() => {
    if (!search) {
      return data;
    }
    const searchText = search.toLowerCase()

    return data.filter((item) => {
      return item.name?.toLowerCase().includes(searchText) || item.description?.toLowerCase().includes(searchText)
    })
  }, [search, data])

  return <div className={classNames(outStyles.cardContainer, 'mt-1')}>
    <div className={classNames('flex-space-btw', outStyles.cardHeader)}>
      <Space>
        <div>Heat and Material Balances</div>
        <div><Search placeholder="Filter the flows" allowClear onInput={(e: any) => onSearch(e.target.value)} style={{ width: 200 }} onClear={onSearch} /></div>
      </Space>
    </div>
    <div className={outStyles.cardBody}>
      {filteredData.map((item) => {
        return <MaterialBalanceCard pId={projectId} balance={item} key={item.id} reload={() => refresh()} />
      })}
      <OPermission permissions={ROLE_CHEMENG}>
        <CreateMaterialBalanceCard pId={projectId} reload={() => refresh()}/>
      </OPermission>
    </div>
  </div>
}